// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { success } from 'react-notification-system-redux'
import triggerFileDownload from 'helpers/triggerFileDownload'
import useJobPollingNotification from 'hooks/useJobPollingNotification'

const useGeneratingMessage = (exportJobId, initialJobStatus, uid) => {
  const dispatch = useDispatch()

  const handleJobDoneCallback = useCallback(({ fileUrl, message }) => {
    // if there's a fileUrl, download it!
    if (fileUrl) {
      triggerFileDownload(fileUrl)
    } else if (message) {
      dispatch(success({
        autoDismiss: 10,
        message: (
          <p id={'job-done-callback-with-message-but-no-fileUrl'}>{message}</p>
        ),
      }))
    }
  }, [])

  return useJobPollingNotification(exportJobId, initialJobStatus, handleJobDoneCallback, uid)
}

export default useGeneratingMessage
